import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CountryStateService {
  private selectedCountrySubject = new BehaviorSubject<string>('ES');
  selectedCountry$ = this.selectedCountrySubject.asObservable();

  setSelectedCountry(code: string) {
    this.selectedCountrySubject.next(code);
  }
}